import React, {Component} from 'react';
import {connect} from 'react-redux'
import LineComponent from './LineComponent';
import NameComponent from './NameComponent';
import { Col, Row, Badge } from 'reactstrap';
import TextInputComponent from './TextInputComponent';
import LODComponent from './LODComponent';
import SearchingTitleComponent from './SearchingTitleComponent';
import { GetListAttempt_ACTION, GetMultipleListAttempt_ACTION, GetListObjectAttemptPost_ACTION, GetMultipleListDataPoolAttempt_ACTION } from '../Actions/LogisticActions';
import { Routes } from '../Services/API';
import DropDownComponent from './DropDownComponent';
import DropdownItem from 'reactstrap/lib/DropdownItem';
import { GetPagesArray } from '../Services/Utilities';

class SearchQuestionsComponent extends Component {
    constructor(props){
        super(props)

        this.state = {
            Expanded: true,
            SelectedLODId:-1,
            SelectedTopicIndex: -1,
            SelectedSubtopicIndex:-1,
            PagesIndex: 2,
            PagesdropdownOpen: false,
            QuestionsPerPageValues:[10,20,50],
            Page:0,
            SelectedPage:1,
            NumberOfQuestions: 0,
            QCodes:[],
            ShowClickableQuestions:true,
            ShowKeyboardQuestions:true,
            ShowMultipleChoiceQuestions:true,
            ShowEBQuestions: true,
            LatestSearch:{
                Subgroup: -1, 
                LevelOfDifficulty:-1,
                Code:null,
                Page:0,
                QperPage:50,
                NumberOfQuestions: 0,
                ShowClickableQuestions: true,
                ShowKeyboardQuestions: true,
                ShowMultipleChoiceQuestions:true,
            },
            
            Recalculate: true,

        }
    }

    componentDidMount(){
        this.props.GetTopics()
    }

    UNSAFE_componentWillReceiveProps(nextprops){
        console.log("nextprops")
        console.log(nextprops)
        if(nextprops.Questions && nextprops.Questions.NumberOfQuestions != undefined && nextprops.Questions.NumberOfQuestions != this.state.NumberOfQuestions){
            this.setState({
                NumberOfQuestions: nextprops.Questions.NumberOfQuestions,
                QCodes: nextprops.Questions.Codes
            })
        }
    }

    componentWillUpdate(bextProps, nextState){
        if(this.props.Father){
            this.props.Father.setState({
                SearchParameters:({
                    ...nextState.LatestSearch,
                }),
                GetOwned: nextState.GetOwned
            })
        }
       
    }

    render(){
        console.log(this.state.NumberOfQuestions)
        console.log(this.state.Recalculate)
        return(
       <div style = {{ flexDirection:'column',display:'flex', alignItems:'center', alignContent:'center', width: '100%'}}>
               { this.state.Expanded ? <Row style = {{width:'100%'}}>
                   {this.props.Collapsable ? 
                   <Col xs = {1}>
                       <Badge color = "warning" style = {{cursor:'pointer'}} onClick = {() => {
                           this.setState({
                               Expanded: false
                           })
                       }}>
                           Minimize search tool
                       </Badge>
                   </Col> : <div/>}
                    <Col xs = {this.props.Collapsable ? 3 : 4}>
                        <NameComponent text = "Code" textColor = "black"/>
                    </Col>
                    <Col xs = {4}>
                        <NameComponent text = "Level Of Difficulty" textColor = "black"/>
                    </Col>
                    <Col xs = {4}>
                        <NameComponent text = "Topic/Subtopic" textColor = "black"/>
                    </Col>
                </Row> :
                <Row style = {{width:'100%', margin:5}} className = "border border-secondary">
                    <Col xs = {3}>
                    <h3>
                        <Badge color = "primary" style = {{cursor: 'pointer'}} onClick = {() => {
                            this.setState({
                                Expanded: true
                            })
                        }}>Expand search tool</Badge>
                    </h3>
                    </Col>
                    {this.state.Code ? 
                    <Col xs = {2}>
                        <h5>
                            {this.state.Code}
                        </h5>
                    </Col> : <div/>}
                    {this.state.SelectedLODId != -1 ? 
                    <Col xs = {1}>
                        <h5 style = {{color: this.props.LODs.filter((l) => l.Id == this.state.SelectedLODId)[0].HexColor}}>
                            {this.props.LODs.filter((l) => l.Id == this.state.SelectedLODId)[0].Name}
                        </h5>
                    </Col> : <div/>}
                    {this.state.SelectedTopicIndex != -1 ? 
                    <Col xs = {3}>
                       <h5 style = {{color:'#0099cc'}}>
                            {this.props.Topics[this.state.SelectedTopicIndex].Name}
                       </h5>
                    </Col> : <div/>}
                    {this.state.SelectedSubtopicIndex != -1 ? 
                    <Col xs = {3}>
                       <h5 style = {{color:'#0099cc'}}>
                            {this.props.Topics[this.state.SelectedTopicIndex].Subtopics[this.state.SelectedSubtopicIndex].Name}
                        </h5>
                    </Col> : <div/>}
                    <Col xs = {3} style = {{flexDirection:'row', display:'flex'}}>
                        <p style = {{color:'green', fontWeight:'bold', width:'100%'}}>{this.state.QuestionsPerPageValues[this.state.PagesIndex]} Questions per page</p>
                  
                    </Col>
                    <Col xs = {2} style = {{flexDirection:'row', display:'flex'}}>
                        <p style = {{color:'#0099cc', fontWeight:'bold', width:'100%'}}>{this.state.NumberOfQuestions} Search results</p>
                    </Col>
                </Row>
            }
                { this.state.Expanded ?<Row style = {{width:'100%'}}>
                    <Col xs = {4}>
                        <TextInputComponent TextValue = {this.state.Code} UpdateValue = {(v) => this.setState({Code:v.target.value, Recalculate: true })}/>
                    </Col>
                    <Col xs = {4}>
                        <LODComponent Object = {this}/>
                    </Col>
                    <Col xs = {4}>
                    {(this.props.IsTopicsSearching || this.props.IsTopicsSearching == undefined || this.GetTopicsError)? 
                                <SearchingTitleComponent error = {this.props.GetTopicsError} onError = {() => this.props.GetTopics()}/>
                                        : 
                                <div style = {{flexDirection:'row', display:'flex', overflowX:'scroll'}}>
                                    {this.props.Topics.map((t, i) =>
                                    (
                                        <div key = {i} style = {{marginRight:20, cursor:'pointer'}} onClick = {(e) => {
                                            this.setState({
                                                SelectedTopicIndex:i == this.state.SelectedTopicIndex ? -1 : i,
                                                SelectedSubtopicIndex: -1,
                                                Recalculate: true
                                            })

                                         
                                        }}>
                                            <h3>
                                                <Badge color = {this.state.SelectedTopicIndex == i ? "success" : "secondary"}>{t.Name}</Badge>
                                            </h3>
                                        </div>
                                    ))}
                                </div>}
                                {this.state.SelectedTopicIndex != -1 ? 
                                (
                                    <div style = {{flexDirection:'row', display:'flex', overflowX:'scroll'}}>
                                        {this.props.Topics[this.state.SelectedTopicIndex].Subtopics.map((s, i) =>
                                        (
                                            <div key = {i} style = {{marginRight:20, cursor:'pointer'}} onClick = {(e) => {
                                                this.setState({
                                                    SelectedSubtopicIndex:i,
                                                    Recalculate: true
                                                })
                                            }}>
                                                <h3>
                                                    <Badge color = {this.state.SelectedSubtopicIndex == i ? "success" : "secondary"}>{s.Name}</Badge>
                                                </h3>
                                            </div>))}
                                    </div>

                                        ) : <div />}
                    </Col>
                </Row> : <div/>}
                { this.state.Expanded ?<hr/> : <div/>}
                { this.state.Expanded ? <Row style = {{width:'100%'}}>
                <Col xs = {3} style = {{cursor: 'pointer', borderRight:1, borderRightColor:'#cccccc', borderRightStyle:'solid'}}
                          onClick = {() => {
                              this.setState({
                                ShowClickableQuestions: !this.state.ShowClickableQuestions,
                                Recalculate: true
                              })
                          }}>
                      <h5 style = {{color:this.state.ShowClickableQuestions ? 'green':'black', fontWeight:this.state.ShowClickableQuestions ? 'bold' : 'normal'}}>

                            Clickable Questions {this.state.ShowClickableQuestions ? ' ✔️' : ''} 
                      </h5>
                  </Col>
                  <Col xs = {3} style = {{cursor: 'pointer', borderRight:1, borderRightColor:'#cccccc', borderRightStyle:'solid'}}
                          onClick = {() => {
                              this.setState({
                                ShowKeyboardQuestions: !this.state.ShowKeyboardQuestions,
                                Recalculate: true
                              })
                          }}>
                      <h5 style = {{color:this.state.ShowKeyboardQuestions ? 'green':'black', fontWeight:this.state.ShowKeyboardQuestions ? 'bold' : 'normal'}}>
                       Keyboard Questions{this.state.ShowKeyboardQuestions ? ' ✔️' : ''}
                      </h5>
                  </Col>
                  <Col xs = {3} style = {{cursor: 'pointer', borderRight:0, borderRightColor:'#cccccc', borderRightStyle:'solid'}}
                          onClick = {() => {
                              this.setState({
                                ShowMultipleChoiceQuestions: !this.state.ShowMultipleChoiceQuestions,
                                Recalculate: true
                              })
                          }}>
                      <h5 style = {{color:this.state.ShowMultipleChoiceQuestions ? 'green':'black', fontWeight:this.state.ShowMultipleChoiceQuestions ? 'bold' : 'normal'}}>
                       Multiple Choice Questions{this.state.ShowMultipleChoiceQuestions ? ' ✔️' : ''}
                      </h5>
                  </Col>
                  <Col xs = {3} style = {{cursor: 'pointer', borderRight:0, borderRightColor:'#cccccc', borderRightStyle:'solid'}}
                          onClick = {() => {
                              this.setState({
                                ShowEBQuestions: !this.state.ShowEBQuestions,
                                Recalculate: true
                              })
                          }}>
                      <h5 style = {{color:this.state.ShowEBQuestions ? 'green':'black', fontWeight:this.state.ShowEBQuestions ? 'bold' : 'normal'}}>
                       Energy Balance Questions{this.state.ShowEBQuestions ? ' ✔️' : ''}
                      </h5>
                  </Col>
              </Row> : <div/>}
              { this.state.Expanded ?<hr/> : <div/>}
              { this.state.Expanded ?<Row style = {{width:'100%'}}>
                    <Col xs = {2} style = {{cursor:'pointer'}} onClick = {() =>{
                         this.props.GetQuestions({

                            Subgroup: this.state.SelectedTopicIndex != -1 && this.state.SelectedSubtopicIndex != -1 ?
                            this.props.Topics[this.state.SelectedTopicIndex].Subtopics[this.state.SelectedSubtopicIndex].Id : -1, 
    
                            LevelOfDifficulty: this.state.SelectedLODId,
    
                            Code:this.state.Code,
                            Page:0,
                            QperPage:this.state.QuestionsPerPageValues[this.state.PagesIndex],
                            NumberOfQuestions: this.state.NumberOfQuestions,
                            ShowClickableQuestions: this.state.ShowClickableQuestions,
                            ShowKeyboardQuestions: this.state.ShowKeyboardQuestions,
                            ShowMultipleChoiceQuestions: this.state.ShowMultipleChoiceQuestions,
                            ShowEBQuestions: this.state.ShowEBQuestions,
    
                            Recalculate: this.state.Recalculate,
                            GetIdsTypes: this.props.GetIdsTypes
                            
                            })

                            this.setState({
                                Recalculate: false,
                                LatestSearch: {
                                    Subgroup: this.state.SelectedTopicIndex != -1 && this.state.SelectedSubtopicIndex != -1 ?
                                    this.props.Topics[this.state.SelectedTopicIndex].Subtopics[this.state.SelectedSubtopicIndex].Id : -1, 
            
                                    LevelOfDifficulty: this.state.SelectedLODId,
            
                                    Code:this.state.Code,
                                    Page:0,
                                    QperPage:this.state.QuestionsPerPageValues[this.state.PagesIndex],
                                    NumberOfQuestions: this.state.NumberOfQuestions,
                                    ShowClickableQuestions: this.state.ShowClickableQuestions,
                                    ShowKeyboardQuestions: this.state.ShowKeyboardQuestions,
                                    ShowMultipleChoiceQuestions: this.state.ShowMultipleChoiceQuestions,
                                    ShowEBQuestions: this.state.ShowEBQuestions,
                                    GetIdsTypes: this.props.GetIdsTypes
                                },
                                GetOwned: false,
                                Expanded: this.props.Collapsable ? false : true,
                                SelectedPage:1

                            })

                            if(this.props.Father){
                                this.props.Father.setState({
                                    ZeroIndex: 0
                                })
                               }
                    }}>
                        <NameComponent text = "Search" textColor = "white" backgroundColor = "#0099cc" />
                    </Col>
                    <Col xs = {1}>
                    </Col>
                    <Col xs = {2} style = {{cursor:'pointer'}} onClick = {() => {
                        this.props.GetQuestions({
                            Subgroup: -1, 
                            LevelOfDifficulty:-1,
                            Code:null,
                            Page:0,
                            QperPage:this.state.QuestionsPerPageValues[this.state.PagesIndex],
                            NumberOfQuestions: this.state.NumberOfQuestions,
                            ShowClickableQuestions: true,
                            ShowKeyboardQuestions: true,
                            ShowMultipleChoiceQuestions:true,
                            ShowEBQuestions: this.state.ShowEBQuestions,
    
                            Recalculate: this.state.Recalculate,
                            GetIdsTypes: this.props.GetIdsTypes
                        })

                        this.setState({
                            Recalculate: false, 
                            LatestSearch: {
                                Subgroup: -1, 
                                LevelOfDifficulty:-1,
                                Code:null,
                                Page:0,
                                QperPage:this.state.QuestionsPerPageValues[this.state.PagesIndex],
                                NumberOfQuestions: this.state.NumberOfQuestions,
                                ShowClickableQuestions: true,
                                ShowKeyboardQuestions: true,
                                ShowMultipleChoiceQuestions:true,
                                ShowEBQuestions: this.state.ShowEBQuestions,
                                GetIdsTypes: this.props.GetIdsTypes
                            },
                            GetOwned: false,
                            Expanded: this.props.Collapsable ? false : true,
                            SelectedPage:1

                        })

                        if(this.props.Father){
                            this.props.Father.setState({
                                ZeroIndex: 0
                            })
                           }
                    }}>
                        <NameComponent text = {this.props.GetText || "Get All"} textColor = "white" backgroundColor = "green" />
                    </Col>
                    <Col xs = {1}>
                    </Col>
                   {this.props.GetOwned ?  
                   <Col xs = {2} style = {{cursor:'pointer'}} onClick = {() => {
                        this.props.GetOwnedQuestions({
                            Subgroup: -1, 
                            LevelOfDifficulty:-1,
                            Code:null,
                            Page:0,
                            QperPage:this.state.QuestionsPerPageValues[this.state.PagesIndex],
                            NumberOfQuestions: this.state.NumberOfQuestions,
                            ShowClickableQuestions: true,
                            ShowKeyboardQuestions: true,
                            ShowMultipleChoiceQuestions:true,
                            ShowEBQuestions: this.state.ShowEBQuestions,
                            GetIdsTypes: this.props.GetIdsTypes
                        })

                        this.setState({
                            GetOwned: true,
                            Expanded: this.props.Collapsable ? false : true,
                            SelectedPage:1

                        })

                        if(this.props.Father){
                            this.props.Father.setState({
                                ZeroIndex: 0
                            })
                           }
                   }}>
                        <NameComponent text = {"Get Owned Questions"} textColor = "white" backgroundColor = "green" />
                    </Col> : <div/>}
                    <Col xs = {3} style = {{flexDirection:'row', display:'flex'}}>
                        <p style = {{color:'green', fontWeight:'bold', width:'100%'}}>Questions per page</p>
                  
                    <DropDownComponent
                        isOpen = {this.state.PagesdropdownOpen}

                        Value = {this.state.QuestionsPerPageValues[this.state.PagesIndex]}
                                
                        toggle = {() => this.setState(prev => ({
                            PagesdropdownOpen: !prev.PagesdropdownOpen
                                }))}

                        >
                        {(this.state.QuestionsPerPageValues).map((v, index) => (
                                    <DropdownItem
                                    onClick = {(e) => {
                                        this.setState({
                                            PagesIndex:index,
                                            PagesdropdownOpen:false,
                                            Page:0
                                        })
                                    }}>
                                        {v}
                                    </DropdownItem>
                                ))} 
                        </ DropDownComponent>
                    </Col>
                    <Col xs = {1} style = {{flexDirection:'row', display:'flex'}}>
                        <p style = {{color:'#0099cc', fontWeight:'bold', width:'100%'}}>{this.state.NumberOfQuestions} Search results</p>
                    </Col>
                </Row> : <div/>}
                <Row style = {{width:'100%', alignContent:'flex-start', alignItems:'flex-start'}}>
                    {this.state.NumberOfQuestions ? 
                    GetPagesArray(this.state.NumberOfQuestions,  this.state.QuestionsPerPageValues[this.state.PagesIndex], this.state.QCodes).map((a) => (
                        <Col xs = {1} onClick = {() => {
                            this.setState({
                                SelectedPage: a.Index
                            })

                            if(!this.state.GetOwned){
                                this.props.GetQuestions({

                                    /*Subgroup: this.state.SelectedTopicIndex != -1 && this.state.SelectedSubtopicIndex != -1 ?
                                    this.props.Topics[this.state.SelectedTopicIndex].Subtopics[this.state.SelectedSubtopicIndex].Id : -1, 
            
                                    LevelOfDifficulty: this.state.SelectedLODId,
            
                                    Code:this.state.Code,
                                    QperPage:this.state.QuestionsPerPageValues[this.state.PagesIndex],
                                    NumberOfQuestions: this.state.NumberOfQuestions,
    
                                    ShowClickableQuestions: this.state.ShowClickableQuestions,
                                    ShowKeyboardQuestions: this.state.ShowKeyboardQuestions,
                                    ShowMultipleChoiceQuestions: this.state.ShowMultipleChoiceQuestions,*/
                                    ...this.state.LatestSearch,
                                    Page:a.Index - 1,
                                    QperPage:this.state.QuestionsPerPageValues[this.state.PagesIndex],
    
                                    Recalculate: false,
                                    GetIdsTypes: this.props.GetIdsTypes
                                })
                            }
                            else{
                                this.props.GetOwnedQuestions({
                                    Subgroup: -1, 
                                    LevelOfDifficulty:-1,
                                    Code:null,
                                    Page:a.Index - 1,
                                    QperPage:this.state.QuestionsPerPageValues[this.state.PagesIndex],
                                    NumberOfQuestions: this.state.NumberOfQuestions,
                                    ShowClickableQuestions: true,
                                    ShowKeyboardQuestions: true,
                                    ShowMultipleChoiceQuestions:true,
                                    ShowEBQuestions: this.state.ShowEBQuestions,
                                    GetIdsTypes: this.props.GetIdsTypes
                                })
        
                                this.setState({
                                    GetOwned: true
                                })
                            }

                           if(this.props.Father){
                            this.props.Father.setState({
                                ZeroIndex: this.state.QuestionsPerPageValues[this.state.PagesIndex] *(a.Index-1)
                            })
                           }

                           
                        }} style = {{cursor:'pointer', border:1, borderStyle:'solid', borderColor: this.state.SelectedPage == a.Index ? 'green' : '#cccccc', margin:2,
                            flexDirection:'row', display:'flex', alignItems:'center',alignContent:'center'}}>
                            <h6 style = {{width:'100%', textAlign:'center'}}>{a.Index + a.Character}</h6>
                        </Col>
                    )) : '-'}
                </Row>
                
            </div> 
        )
    }
}

//Constant
const TOPICS_SEARCHING_PARAMETER = 'IsTopicsSearching'

const TOPICS_DATA_PARAMETER = 'Topics'

const TOPICS_GET_ERROR_PARAMETER = 'TopicsGetError'

const LOD_SEARCHING_PARAMETER = 'IsLODSearching'

const LOD_DATA_PARAMETER = 'LODs'

const LOD_GET_ERROR_PARAMETER = 'LODsGetError'
//
const QUESTIONS_SEARCHING_PARAMETER = 'IsCQuestionsSearching'

const QUESTIONS_DATA_PARAMETER = 'CQuestions'

const QUESTIONS_GET_ERROR_PARAMETER = 'CQuestionsGetError'
//
const QUESTION_SEARCHING_PARAMETER = 'IsQuestionSearching'

const QUESTION_DATA_PARAMETER = 'Question'

const QUESTION_GET_ERROR_PARAMETER = 'QuestionGetError'

function MapStateToProps(state) {
    return {
      Topics:state.Query[TOPICS_DATA_PARAMETER],
      IsTopicsSearching: state.Query[TOPICS_SEARCHING_PARAMETER],
      GetTopicsError: state.Query[TOPICS_GET_ERROR_PARAMETER],
      Questions: state.Query[QUESTIONS_DATA_PARAMETER],
      LODs:state.Query[LOD_DATA_PARAMETER],

    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        GetTopics: () => {dispatch(GetMultipleListDataPoolAttempt_ACTION([
            {
                SearchParameter: LOD_SEARCHING_PARAMETER,
                DataParameter: LOD_DATA_PARAMETER,
                GetErrorParameter: LOD_GET_ERROR_PARAMETER,
                Path: Routes.GetLevelsOfDifficulty,
        
                [LOD_SEARCHING_PARAMETER]: true,
                
                [LOD_DATA_PARAMETER]: [],
        
                [LOD_GET_ERROR_PARAMETER]: '',
            },
            {
                SearchParameter: TOPICS_SEARCHING_PARAMETER,
                DataParameter: TOPICS_DATA_PARAMETER,
                GetErrorParameter: TOPICS_GET_ERROR_PARAMETER,
                Path: Routes.GetAllTopics,
        
                [TOPICS_SEARCHING_PARAMETER]: true,
                
                [TOPICS_DATA_PARAMETER]: [],
        
                [TOPICS_GET_ERROR_PARAMETER]: '',
            }
        ]))},
        GetQuestions: (values) => {dispatch(GetListObjectAttemptPost_ACTION({
            SearchParameter: QUESTIONS_SEARCHING_PARAMETER,
            DataParameter: QUESTIONS_DATA_PARAMETER,
            GetErrorParameter: QUESTIONS_GET_ERROR_PARAMETER,
            Path: Routes.GetQuestionsAdvancedSearch,
            Body: values,
    
            [QUESTIONS_SEARCHING_PARAMETER]: true,
            
            [QUESTIONS_DATA_PARAMETER]: [],
    
            [QUESTIONS_GET_ERROR_PARAMETER]: ''
        }))},
        GetOwnedQuestions: (values) => {dispatch(GetListObjectAttemptPost_ACTION({
            SearchParameter: QUESTIONS_SEARCHING_PARAMETER,
            DataParameter: QUESTIONS_DATA_PARAMETER,
            GetErrorParameter: QUESTIONS_GET_ERROR_PARAMETER,
            Path: Routes.GetOwnedQuestionsSearch,
            Body: values,

            [QUESTIONS_SEARCHING_PARAMETER]: true,
            
            [QUESTIONS_DATA_PARAMETER]: [],
    
            [QUESTIONS_GET_ERROR_PARAMETER]: ''
        }))}
    }
  }
  
export default connect(MapStateToProps, MapDispatchToProps)(SearchQuestionsComponent)